<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Clientes morosos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Cuenta corriente</span>
            <span> /</span>
            <span>Clientes morosos</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
    <div class="card mb-2 wow detalle-cliente">
        <div class="card-body justify-content-between">
            <div class="row filtros-body">
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
                            formControlName="fechaDesde">
                        </mdb-date-picker>
                        <div *ngIf="
                                formHeader.get('fechaDesde').invalid &&
                                (formHeader.get('fechaDesde').dirty ||
                                formHeader.get('fechaDesde').touched)
                            ">
                            <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                                Ingrese fecha desde
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col" style="max-width: 200px;">
                    <div class="md-form">
                        <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
                            formControlName="fechaHasta">
                        </mdb-date-picker>
                        <div *ngIf="
                            formHeader.get('fechaHasta').invalid &&
                            (formHeader.get('fechaHasta').dirty ||
                            formHeader.get('fechaHasta').touched)
                        ">
                            <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">
                                Ingrese fecha hasta
                            </mdb-error>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row filtros-body align-items-center">

                <div [ngClass]="{'col': true, disabledContent: !enableClienteInputs}" style="max-width: 150px;">
                    <div class="md-form">
                        <input value="" type="text" id="rutcliente" class="form-control" placeholder="" #rutcliente
                            formControlName="rutCliente" formatRut />
                        <label for="rutcliente">RUT cliente</label>
                        <!-- <div *ngIf="
                            formHeader.get('rutCliente').invalid &&
                            (formHeader.get('rutCliente').dirty ||
                            formHeader.get('rutCliente').touched)
                          ">
                            <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">Ingrese cliente
                            </mdb-error>
                        </div> -->
                    </div>
                </div>
                <div [ngClass]="{'col d-flex': true, disabledContent: !enableClienteInputs}" style="max-width: 300px;">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="abrirModalSeleccionarCliente()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" style="display: contents;" *ngIf="clienteSeleccionado">
                        {{ clienteSeleccionado.razon_social }}
                    </h6>
                </div>
                <div class="col" style="max-width: 150px;">
                    <mdb-checkbox formControlName="todosClientes">Todos</mdb-checkbox>
                </div>

                <div [ngClass]="{'col': true, disabledContent: !enableVendedorInputs}" style="max-width: 150px;">
                    <div class="md-form">
                        <input value="" type="text" id="rutvende" class="form-control" placeholder="" #rutvende
                            formControlName="rutVendedor" formatRut />
                        <label for="rutvende">RUT vendedor</label>
                        <!-- <div *ngIf="
                                formHeader.get('rutVendedor').invalid &&
                                (formHeader.get('rutVendedor').dirty ||
                                formHeader.get('rutVendedor').touched)
                            ">
                            <mdb-error *ngIf="formHeader.get('rutVendedor').hasError('required')">
                                Ingrese rut vendedor
                            </mdb-error>
                        </div> -->
                    </div>
                </div>
                <div [ngClass]="{'col d-flex': true, disabledContent: !enableVendedorInputs}" style="max-width: 300px;">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="abrirModalSeleccionarVendedor()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" style="display: contents;">
                        {{ vendedorSeleccionado?.nombre }}
                    </h6>
                </div>
                <div class="col" style="max-width: 150px;">
                    <mdb-checkbox formControlName="todosVendedores">Todos</mdb-checkbox>
                </div>
            </div>
        </div>
        <!-- FOOTER -->
        <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
                <mdb-icon fas icon="search"></mdb-icon>
                Buscar
            </button>
        </div>
    </div>
</form>

<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">

        <div class="table-responsive" *ngIf="listaRegistros">

            <table class="table table-striped table-hover table-sm align-middle">
                <thead class="grey lighten-2">
                    <tr>
                        <th scope="col">RUT</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Nro. Doc.</th>
                        <th scope="col">Fecha Doc.</th>
                        <th scope="col">Fecha Venc.</th>
                        <th scope="col">Vendedor</th>
                        <th scope="col">Código Vendedor</th>
                        <th scope="col">Monto</th>
                        <th scope="col">Pago</th>
                        <th scope="col">Saldo</th>
                        <th scope="col">D.V. 01/07</th>
                        <th scope="col">D.V. 08/15</th>
                        <th scope="col">D.V. 16-30</th>
                        <th scope="col">D.V. +30</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="loading">
                        <td colspan="100%" style="text-align: center">
                            <mdb-spinner spinnerColor="blue"></mdb-spinner>
                        </td>
                    </tr>
                    <tr *ngIf="!loading && listaRegistros?.length === 0">
                        <td colspan="100%" style="text-align: center">
                            No se encontró información
                        </td>
                    </tr>
                    <tr *ngFor="let reg of listaRegistros">
                        <td>{{reg.rutFormato | rut}}</td>
                        <td>{{reg.razonSocialCliente}}</td>
                        <td>{{reg.nombreTipoDocto}}</td>
                        <td>{{reg.folio}}</td>
                        <td>{{reg.fecha_emision | fecha}}</td>
                        <td>{{reg.fechaVencimientoDocto | fecha}}</td>
                        <td>{{reg.vendedor_nombre}}</td>
                        <td>{{reg.vendedor_codigo}}</td>
                        <td>$ {{reg.total_monto | numerico}}</td>
                        <td>$ {{reg.pago | numerico }}</td>
                        <td>$ {{reg.saldo | numerico }}</td>
                        <td>{{reg.dv0107}}</td>
                        <td>{{reg.dv0815}}</td>
                        <td>{{reg.dv1630}}</td>
                        <td>{{reg.dv30mas}}</td>
                    </tr>
                </tbody>
                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaRegistros?.length > 0"></app-pagination>
            </table>
        </div>
    </div>
</div>

<div class="card mb-2 wow" *ngIf="listaRegistros?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">
        <button mdbBtn type="button" color="success" mdbWavesEffect (click)="exportarExcel()">
            EXCEL
        </button>
        <button mdbBtn type="button" color="success" mdbWavesEffect>
            PDF
        </button>
    </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" (onSelectSingle)="onClienteSeleccionado($event)"
  queryType="ONLY_RUT_BLO_DESB" showInfoClienteInactivoBloqueado="true" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [multiple]="false" queryType="ONLY_RUT"
    (onSelectSingle)="onVendedorSeleccionado($event)" (onNotFound)="onVendedorNoEncontrado()">
</app-modal-seleccionar-vendedor>
